import React from "react"
import { Flex, Box } from "rebass"
import ThrottleBwTable from "../ThrottleBwTable"
import UsageSummary from "../UsageSummary"

const ThrottleBwDisplay = ({
  monthData: { bandwidth, label, total, nightTotal, cap, remainingGigs },
  active,
  idx,
  nightGigs,
}) => {
  const col1 = bandwidth.slice(0, 15)
  const col2 = bandwidth.slice(15)

  return (
    <Flex flexDirection="column">
      <UsageSummary
        isThrottle={true}
        nightGigs={nightGigs}
        nightTotal={nightTotal}
        total={total}
        cap={cap}
        remainingGigs={remainingGigs}
      />
      <Flex flexWrap="wrap">
        <Box pr={2} pb={2} width={[1, 1, 1, 1 / 2]} flex={1}>
          <ThrottleBwTable nightGigs={nightGigs} bandwidth={col1} />
        </Box>
        <Box width={[1, 1, 1, 1 / 2]} flex={1}>
          <ThrottleBwTable nightGigs={nightGigs} bandwidth={col2} />
        </Box>
      </Flex>
    </Flex>
  )
}

export default ThrottleBwDisplay
